import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dataVersion: 0,
  sitePath: '',
  tab_or_publication_page: '',
  lastPublicationNumber: null,
  preventScrollOnNavigation: false,
  isBrowserNavigation: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setDataVersion: (state, action) => {
      state.dataVersion = action.payload;
    },
    incrementDataVersion: (state) => {
      state.dataVersion += 1;
    },
    setSitePath: (state, action) => {
      state.sitePath = action.payload;
    },
    setTabOrPublicationPage: (state, action) => {
      state.tab_or_publication_page = action.payload;
    },
    setLastPublicationNumber: (state, action) => {
      state.lastPublicationNumber = action.payload;
    },
    setPreventScrollOnNavigation: (state, action) => {
      state.preventScrollOnNavigation = action.payload;
    },
    setIsBrowserNavigation: (state, action) => {
      state.isBrowserNavigation = action.payload;
    },
  },
});

export const {
  setDataVersion,
  incrementDataVersion,
  setSitePath,
  setTabOrPublicationPage,
  setLastPublicationNumber,
  setPreventScrollOnNavigation,
  setIsBrowserNavigation,
} = appSlice.actions;

export default appSlice.reducer;
